"use strict";
var uncurryThis = require("../internals/function-uncurry-this");
var aCallable = require("../internals/a-callable");
module.exports = function(object, key, method) {
  try {
    return uncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) {
  }
};
